export { default } from "./usePrincipalGet";
